import QRCode from 'qrcode.react'

interface PropsQRCodeGenerator {
    value: string
    documentId: string
}

function QRGenerator({ value, documentId }: PropsQRCodeGenerator) {
    return (
        <div>
            <QRCode
                id={documentId}
                value={value}
                size={144}
                bgColor="#FFF"
                fgColor="#000"
                includeMargin
                level={'H'}
            />
        </div>
    )
}

export default QRGenerator
